export default "__VITE_ASSET__D2fk6RAI__"